var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003A5D",
    d: "M9.317 12l5.442 6.35a1 1 0 11-1.518 1.3l-6-7a.998.998 0 010-1.3l6-7a1 1 0 111.518 1.3L9.317 12z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCAwSDI0VjI0SDB6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjI4IC05NjEpIHRyYW5zbGF0ZSg2MTYgOTQ5KSB0cmFuc2xhdGUoMTIgMTIpIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iIzAwM0E1RCIgZD0iTTkuMzE3IDEybDUuNDQyIDYuMzVjLjM2LjQxOS4zMTEgMS4wNS0uMTA4IDEuNDEtLjQyLjM1OS0xLjA1LjMxLTEuNDEtLjExbC02LTdjLS4zMjEtLjM3NC0uMzIxLS45MjYgMC0xLjNsNi03Yy4zNi0uNDIuOTktLjQ2OSAxLjQxLS4xMS40Mi4zNi40NjguOTkxLjEwOCAxLjQxTDkuMzE3IDEyeiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTYyOCAtOTYxKSB0cmFuc2xhdGUoNjE2IDk0OSkgdHJhbnNsYXRlKDEyIDEyKSIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgIconsChevronLeft as ReactComponent };